import React from "react";
import propTypes from "prop-types";
import "./ProgressRing.css";
// import icons from "../../data/icons";
import progressImage from '../../assets/images/icons/Icon_DataCenter.png';

class ProgressRing extends React.Component {
  constructor(props) {
    super(props);
    const { radius, stroke } = this.props;
    this.normalizedRadius = radius - stroke * 2;
    this.circumference = this.normalizedRadius * 2 * Math.PI;
  }

  render() {
    const { radius, stroke, progress } = this.props;
    const strokeDashoffset =
      this.circumference - progress / 100 * this.circumference;
    return (
      <section className="icon-container">
        <svg className="progress-circle" height={radius * 2} width={radius * 2}>
          <circle
            stroke="#ff000f"
            fill="white"
            strokeWidth={stroke}
            strokeDasharray={`${this.circumference} ${this.circumference}`}
            style={{ strokeDashoffset }}
            r={this.normalizedRadius}
            cx={radius}
            cy={radius}
          />
        </svg>
        <img className="progressImage" src={progressImage} alt="" />
      </section>
    );
  }
}

ProgressRing.propTypes = {
  radius: propTypes.number.isRequired,
  stroke: propTypes.number.isRequired,
  progress: propTypes.number.isRequired
};

export default ProgressRing;
